import { css } from "@emotion/core";
import { color, fontTypes } from "../../constants/commons";

export const linkButtonStyles = () => css`
  text-transform: uppercase;
  color: ${color.red}!important;
  font-family: ${fontTypes.bold};
`;
